import React from 'react';
import { Link } from 'gatsby';

const CircleBadge = () => (
  <a href="https://ugecredits.com/" target="blank">
    <img src={require('./Circle-badge.png')} alt="Footer UGE Green Icon"></img>
  </a>
);

export default CircleBadge;

/*

const LogoIcon = () => (
  <a href="#features"><img src={ logo } alt="FGC Icon" ></img></a>
);

export default LogoIcon;
*/
